export default {
  state: {
    not_found: false,
    reservation_expired: false,
  },
  mutations: {
    showNotFound(state) {
      state.not_found = true
    },
    hideNotFound(state) {
      state.not_found = false
    },
    showReservationExpired(state) {
      state.reservation_expired = true
    },
    hideReservationExpired(state) {
      state.reservation_expired = false
    },
  },
  getters: {
    isNotFound(state) {
      return state.not_found
    },
    isReservationExpired(state) {
      return state.reservation_expired
    },
  },
}
